// extracted by extract-css-chunks-webpack-plugin
module.exports = {"leftColumn":"_249eu6","dividerClass":"_3bhsVU","authorContent":"_1wQtfJ","flexDirection":"_2D_oWN","renderToolTip":"_1Z41G2"};